import { render, staticRenderFns } from "./fuWu.vue?vue&type=template&id=77af676f"
import script from "./fuWu.vue?vue&type=script&lang=js"
export * from "./fuWu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports